import { render, staticRenderFns } from "./EditPricesModal.vue?vue&type=template&id=7cfc6998&"
import script from "./EditPricesModal.vue?vue&type=script&lang=js&"
export * from "./EditPricesModal.vue?vue&type=script&lang=js&"
import style0 from "./EditPricesModal.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports